import { render, staticRenderFns } from "./ServiceAccessManager.vue?vue&type=template&id=0809c313"
import script from "./ServiceAccessManager.vue?vue&type=script&lang=js"
export * from "./ServiceAccessManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports